import React from "react";
import { useTranslation } from "react-i18next";

export default function DevModeTools(props) {
  const { t } = useTranslation();
  return (
    <li className="draw-toolbar-icon">
      <span
        className={`button normal-btn main-button ${
          props.activeButton === "devmode-tools" ? "active" : ""
        }${props.hideButton ? "passive" : ""}`}
        title={t("DevMode Tools")}
        data-tip={t("DevMode Tools")}
        onClick={props.onClick}
      >
        <img
          src={require("../../assets/img/svg/tools-devmode.svg")}
          alt={t("DevMode Tools")}
        />
      </span>
    </li>
  );
}
